import {SEARCH_REQUEST_SET_TERM} from 'search-request/search-request-actions';
import {
    FILTERS_RESET,
    FILTERS_UPDATE
} from './filters-actions';
import {
    initialAmenities,
    initialReservationTypes
} from './filters-utils';

const initialState = {
    numActive: 0,
    amenities: {...initialAmenities},
    activeAmenities: [],
    reservationTypes: {...initialReservationTypes},
    activeReservationType: 'all',
    price: false
};

export default function filters(state = initialState, {type, payload}) {
    switch (type) {
        case FILTERS_RESET: {
            return initialState;
        }

        case SEARCH_REQUEST_SET_TERM: {
            return {
                ...initialState,
                amenities: {...initialAmenities}
            };
        }

        case FILTERS_UPDATE: {
            const newState = {
                ...state,
                ...payload
            };

            newState.numActive = newState.activeAmenities.length;

            if (newState.activeReservationType !== 'all') {
                newState.numActive++;
            }

            if (newState.price) {
                newState.numActive++;
            }

            return newState;
        }

        default:
            return state;
    }
}
